import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Paper } from '@mui/material'
import { Home, ArrowBack, Explore } from '@mui/icons-material'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        sx={{
          p: 6,
          maxWidth: 600,
          textAlign: 'center',
          border: '2px solid',
          borderColor: 'primary.main',
        }}
      >
        <Box
          sx={{
            fontSize: 120,
            fontWeight: 'bold',
            color: 'primary.main',
            lineHeight: 1,
            mb: 2,
          }}
        >
          404
        </Box>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Trail Not Found
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Looks like you've wandered off the beaten path! The adventure you're looking for doesn't
          exist or may have been moved.
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/')}
            sx={{ textTransform: 'none' }}
          >
            Return to Base Camp
          </Button>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{ textTransform: 'none' }}
          >
            Go Back
          </Button>
          <Button
            variant="outlined"
            startIcon={<Explore />}
            onClick={() => navigate('/adventures')}
            sx={{ textTransform: 'none' }}
          >
            Explore Adventures
          </Button>
        </Box>
      </Paper>
    </Box>
  )
}
